import script from "./ExamAnalysis.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamAnalysis.vue?vue&type=script&setup=true&lang=ts"

import "./ExamAnalysis.vue?vue&type=style&index=0&id=4ca01782&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca01782"]])

export default __exports__